import React, { useState } from "react";
import Button, { ButtonType } from "../Assets/Button";
import { sendToWhatsapp } from "../Assets/generateBill/sendToWhatsapp";
import { IProduct } from "../../models/productData.model";

interface SendToWhatsAppProps {
  currentLead: any;
  selectedCompanyInfo: any;
  setSelectedCompanyInfo: (info: any) => void;
  selectedProducts: any[];
  setSelectedProducts: (products: IProduct[]) => void;
  setShowMobileNumberModal: React.Dispatch<React.SetStateAction<boolean>>;
  showMobileNumberModal: boolean;
  mobileNumberInput: string;
  transportPrice?: number;
  discountPrice?: number;
  setTransportPrice?: React.Dispatch<React.SetStateAction<number>>;
  setMobileNumberInput: (input: string) => void;
  onClose?: () => void;
  type: string;
}

const SendToWhatsApp: React.FC<SendToWhatsAppProps> = ({
  transportPrice,
  discountPrice,
  selectedCompanyInfo,
  setShowMobileNumberModal,
  showMobileNumberModal,
  selectedProducts,
  mobileNumberInput,
  setMobileNumberInput,
  onClose = () => {},
  type,
}) => {
  const [isModalSending, setIsModalSending] = useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");

  if (!showMobileNumberModal) return null; // Prevents unnecessary rendering

  return (
    <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50 z-[999]">
      <div className="bg-white p-6 rounded-lg w-96 shadow-lg relative">
        <h3 className="text-lg font-semibold mb-4 text-center">
          Enter Mobile Number
        </h3>
        <input
          type="text"
          value={mobileNumberInput}
          onChange={(e) => {
            const value = e.target.value.replace(/\D/g, "");
            setMobileNumberInput(value);
            setErrorMessage("");
          }}
          placeholder="Enter 10-digit mobile number"
          className="border p-2 w-full mb-2 text-center"
          maxLength={10}
        />
        {errorMessage && (
          <p className="text-red-500 text-sm mb-2 text-center">
            {errorMessage}
          </p>
        )}
        <div className="flex gap-2 justify-center mt-4">
          <Button
            type={ButtonType.Cancel}
            onClick={() => {
              setShowMobileNumberModal(false);
              setMobileNumberInput("");
              setErrorMessage("");
            }}
            className="px-4 py-2"
          >
            Close
          </Button>
          <Button
            type={ButtonType.Submit}
            onClick={async () => {
              if (isModalSending) {
                return;
              }
              const number = mobileNumberInput;
              if (number.length !== 10 || !/^\d{10}$/.test(number)) {
                setErrorMessage("Please enter a valid 10-digit mobile number");
                return;
              }

              setErrorMessage("");

              const updatedCompanyInfo = {
                ...selectedCompanyInfo,
                mobileNumber: number,
              };

              setIsModalSending(true);
              try {
                await sendToWhatsapp(
                  selectedProducts,
                  updatedCompanyInfo,
                  transportPrice!,
                  discountPrice!,
                  type
                );
              } catch (error) {
                console.error("Error sending to WhatsApp:", error);
              } finally {
                setIsModalSending(false);
                setShowMobileNumberModal(false);
                setMobileNumberInput("");
              }
            }}
            className="px-4 py-2"
          >
            {isModalSending ? "Sending..." : "Send"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SendToWhatsApp;
